// Angular Imports
import { Injectable } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
// Angular Material Imports
import { MatIconRegistry } from '@angular/material/icon'

@Injectable({
	providedIn: 'root',
})
export class RegisterSvgAsIconService {
	constructor(
		private _iconRegistry: MatIconRegistry,
		private _sanitizer: DomSanitizer
	) {
		// Operation
		this._iconRegistry.addSvgIcon(
			'operation.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/operation.svg')
		)
		// Planning
		this._iconRegistry.addSvgIcon(
			'planning.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/planificacion.svg')
		)
		// Drivers
		this._iconRegistry.addSvgIcon(
			'drivers.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/conductores.svg')
		)
		// Locations
		this._iconRegistry.addSvgIcon(
			'locations.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/lugares.svg')
		)
		// Schedules
		this._iconRegistry.addSvgIcon(
			'cronogramas.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/cronogramas.svg')
		)
		// Shifts
		this._iconRegistry.addSvgIcon(
			'turnos.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/turnos.svg')
		)
		// Units
		this._iconRegistry.addSvgIcon(
			'unidades.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/unidades.svg')
		)
		// Pre-Checkin
		this._iconRegistry.addSvgIcon(
			'pre-checkin.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/pre-checkin.svg')
		)
		// Open Shift
		this._iconRegistry.addSvgIcon(
			'open-shift.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/open-shift.svg')
		)
		// Close Shift
		this._iconRegistry.addSvgIcon(
			'close-shift.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/close-shift.svg')
		)
		// Edit Shift
		this._iconRegistry.addSvgIcon(
			'edit-shift.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/edit-shift.svg')
		)
		// Damage
		this._iconRegistry.addSvgIcon(
			'damage.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/sidenav/damage.svg')
		)
		// Square caret left solid
		this._iconRegistry.addSvgIcon(
			'square-caret-left-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl(
				'assets/svgs/icons/square-caret-left-solid.svg'
			)
		)
		// Square caret right solid
		this._iconRegistry.addSvgIcon(
			'square-caret-right-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl(
				'assets/svgs/icons/square-caret-right-solid.svg'
			)
		)
		// Circle user solid
		this._iconRegistry.addSvgIcon(
			'circle-user-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/circle-user-solid.svg')
		)
		// Right from bracket solid
		this._iconRegistry.addSvgIcon(
			'right-from-bracket-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl(
				'assets/svgs/icons/right-from-bracket-solid.svg'
			)
		)
		// Trash solid
		this._iconRegistry.addSvgIcon(
			'trash-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/trash-solid.svg')
		)
		// Trash arrow up solid
		this._iconRegistry.addSvgIcon(
			'trash-arrow-up-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/trash-arrow-up-solid.svg')
		)
		// Square plus solid
		this._iconRegistry.addSvgIcon(
			'square-plus-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/square-plus-solid.svg')
		)
		// Circle plus solid
		this._iconRegistry.addSvgIcon(
			'circle-plus-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/circle-plus-solid.svg')
		)
		// Pen to square solid
		this._iconRegistry.addSvgIcon(
			'pen-to-square-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/pen-to-square-solid.svg')
		)
		// Xmark solid
		this._iconRegistry.addSvgIcon(
			'xmark-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/xmark-solid.svg')
		)
		// Grid vertical solid
		this._iconRegistry.addSvgIcon(
			'grip-vertical-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/grip-vertical-solid.svg')
		)
		// Grip solid
		this._iconRegistry.addSvgIcon(
			'grip-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/grip-solid.svg')
		)
		// Up right and down left from center solid
		this._iconRegistry.addSvgIcon(
			'up-right-and-down-left-from-center-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl(
				'assets/svgs/icons/up-right-and-down-left-from-center-solid.svg'
			)
		)
		// Arrow left solid
		this._iconRegistry.addSvgIcon(
			'arrow-left-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/arrow-left-solid.svg')
		)
		// Arrow right solid
		this._iconRegistry.addSvgIcon(
			'arrow-right-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/arrow-right-solid.svg')
		)
		// Chevron right solid
		this._iconRegistry.addSvgIcon(
			'chevron-right-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/chevron-right-solid.svg')
		)
		// Chevron left solid
		this._iconRegistry.addSvgIcon(
			'chevron-left-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/chevron-left-solid.svg')
		)
		// Ellipsis vertical solid
		this._iconRegistry.addSvgIcon(
			'ellipsis-vertical-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl(
				'assets/svgs/icons/ellipsis-vertical-solid.svg'
			)
		)
		// Filter solid
		this._iconRegistry.addSvgIcon(
			'filter-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/filter-solid.svg')
		)
		// Filter circle xmark solid
		this._iconRegistry.addSvgIcon(
			'filter-circle-xmark-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl(
				'assets/svgs/icons/filter-circle-xmark-solid.svg'
			)
		)
		// Arrows rotate solid
		this._iconRegistry.addSvgIcon(
			'arrows-rotate-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/arrows-rotate-solid.svg')
		)
		// Expand more solid
		this._iconRegistry.addSvgIcon(
			'expand-more.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/expand-more.svg')
		)
		this._iconRegistry.addSvgIcon(
			'calendar-regular.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/calendar-regular.svg')
		)
		this._iconRegistry.addSvgIcon(
			'circle-check-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/circle-check-solid.svg')
		)
		this._iconRegistry.addSvgIcon(
			'circle-exclamation-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl(
				'assets/svgs/icons/circle-exclamation-solid.svg'
			)
		)
		this._iconRegistry.addSvgIcon(
			'circle-info-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/circle-info-solid.svg')
		)
		this._iconRegistry.addSvgIcon(
			'circle-xmark-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/circle-xmark-solid.svg')
		)
		this._iconRegistry.addSvgIcon(
			'eye-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/eye-solid.svg')
		)
		this._iconRegistry.addSvgIcon(
			'eye-slash-solid.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/eye-slash-solid.svg')
		)
		this._iconRegistry.addSvgIcon(
			'circle-xmark-regular.svg',
			this._sanitizer.bypassSecurityTrustResourceUrl('assets/svgs/icons/circle-xmark-regular.svg')
		)
	}
}
